var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-colorOverlay",class:{
    'is-animated': _vm.isAnimated
  },attrs:{"data-scale":_vm.scale}},[_vm._t("default"),_vm._v(" "),_c('div',{ref:"layer",staticClass:"p-colorOverlay__layer"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a94dc8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/color-overlay/component.vue
// module id = null
// module chunks = 